
//import { v4 as uuidv4 } from 'uuid';

import useUserSession, { getItem } from '../hooks/useUserSession';
import { getCommentsAction, setComments, setProductInfo, setThemeMode } from '../store/actions';
import { useStateContext } from '../store/stateContext';
import {
    Comment, CommentRequest, CommentsResponse, LikeRequestBody, PollVoteRequestBody, Product, User
} from '../types';
import { computeWidgetDisplay } from '../utils/widgetDisplay';
import {
    fetchComments, fetchWidgetInfo, postComment, postCommentLike, postImage, postInteraction,
    postPollVote
} from './';

export type ShouldHideWidgetProps=  {
    widget_display_condition: string | null;
    widget_display_action: string | null;
    widget_display_url_pattern: string | null;
    currentPath: string
}




const useApi = () => {
    const { dispatch } = useStateContext();
    const { userInfo } = useUserSession();
    const getWidgetInfo = async (widgetId: string, productId: string) => {
        console.log('[useApi][getWidgetInfo]', widgetId, productId)
        const userFromStore = getItem('user_info');
        const userEmail = userInfo?.email ?? userFromStore?.email ?? '';
        try {
            const response: Product = await fetchWidgetInfo(widgetId, productId) as Product;
            console.log('response', response);
            dispatch(setProductInfo({ product: response }));
            const comment_widget_display_settings = response.comment_widget_display_settings;
            if(!computeWidgetDisplay({ widget_display_action: comment_widget_display_settings.action || '', widget_display_condition: comment_widget_display_settings.condition || '', widget_display_url_pattern: comment_widget_display_settings.url_pattern || '' , currentPath: window.location.pathname })) {
                console.log('$$ hide widget');
                dispatch({ type: 'HIDE_WIDGET' });
                return;
            } else {
                console.log('$$ show widget');
            }
            dispatch(setThemeMode({ mode: response.widget_theme as string }));
            getComments(`${response.id}`, userEmail);
        } catch (error) {
            console.error('Failed to fetch product info:', error);
        }
    }
    const getComments = async (productId: string, userEmail: string) => {
        try {
            dispatch(getCommentsAction());
            const response: CommentsResponse = await fetchComments(productId, userEmail || localStorage.getItem('anonymous_email') || '') as CommentsResponse;
            console.log({ response })
            dispatch(setComments(response));
        } catch (error) {
            console.error('Failed to fetch comments:', error);
        }
    }
    const addComment = async (productId: string, message: string, user: Partial<User> | undefined, commentId?: number, postPurchase = false ) => {
        try {
            const userFromStore = getItem('user_info');
            let imageResponse: any = {}
            if(user?.profilePicture) {
                imageResponse = await postImage(user?.profilePicture as File);
            }
            console.log({ imageResponse })
            const userEmail = userInfo?.email ?? user?.email ?? userFromStore?.email ?? '';
            const anonymousEmail = localStorage.getItem('anonymous_email') || '';
            const comment: CommentRequest = {
                user_email: userEmail,
                user_name: userInfo?.name ?? user?.fullName ?? userFromStore?.name ?? '',
                ...(imageResponse?.name ? {user_image: imageResponse?.name}: {}),
                ...(user?.profilePictureUrl ? {user_image: user?.profilePictureUrl}: {}),
                anonymous_email: anonymousEmail,
                message,
                parent_review_id: commentId || null,
                message_type_id: postPurchase ?  2 : 1,
            }
            console.log({ comment})
            localStorage.removeItem('anonymous_email');
            const response: Comment = await postComment(productId, comment) as Comment;
            console.log({ response })
            getComments(productId, userEmail);
        } catch (error) {
            console.error('Failed to post comment:', error);
            throw error;
        }
    }
    const addReply = (productId: string, message: string, commentId: number, user: Partial<User> | undefined) => {
        addComment(productId, message, user, commentId);
    }
    const likeComment = async (productId: string, commentId: number, like: boolean = true, user: Partial<User> | undefined = undefined) => {
        try {
            const userFromStore = getItem('user_info');
            const userEmail = userInfo?.email ?? user?.email ?? userFromStore?.email ?? '';
            let anonymousEmail = localStorage.getItem('anonymous_email') || '';
            if(!userEmail) {
                if(!localStorage.getItem('anonymous_email')) {
                    const anyId = crypto.randomUUID();
                    anonymousEmail = anyId + "@anonymous.com";
                    localStorage.setItem('anonymous_email', anonymousEmail);
                }
            }
            const body: LikeRequestBody = {
                user_email: userEmail || anonymousEmail,
                user_name: userInfo?.name ?? userFromStore?.name ?? '',
                ...(userInfo?.image ? {user_image: userInfo?.image}: {}),
                liked: like
            }
            console.log({ userInfo, body, ...(userInfo?.image ? {user_image: userInfo?.image}: {}) })
            const response: unknown = await postCommentLike(productId, commentId, body);
            console.log('[likecommentapi]',{ response })
            getComments(productId, userEmail)
        } catch (error) {
            console.error('Failed to like comment:', error);
            throw error;
        }
    }
    const unlikeComment = (productId: string, commentId: number) => {
        likeComment(productId, commentId, false, undefined);
    }
    const updateInteractionTime = async (productId: number, elapsedTime: number) => {
        try {
            const response: unknown = await postInteraction({ id: productId }, elapsedTime);
            console.log({ response });
        } catch (error) {
            console.error('Failed to update interaction time:', error);
        }
    }
    const pollVote = async (productId: string, commentId: number, optionId: number, user: Partial<User> | undefined = undefined) => {
        try {
            const userFromStore = getItem('user_info');
            const userEmail = userInfo?.email ?? user?.email ?? userFromStore?.email ?? '';
            let imageResponse: any = {}
            if(user?.profilePicture) {
                imageResponse = await postImage(user?.profilePicture as File);
            }
            const body: PollVoteRequestBody = {
                user_email: userEmail,
                user_name: userInfo?.name ?? user?.fullName ?? userFromStore?.name ?? '',
                ...(imageResponse?.name ? {user_image: imageResponse?.name}: {}),
                ...(user?.profilePictureUrl ? {user_image: user?.profilePictureUrl}: {}),
                poll_option_id: optionId

            }
            const response: unknown = await postPollVote(productId, commentId, body);
            console.log({ response });
            getComments(productId, userEmail)
        } catch(error) {
            console.error('Failed to vote on poll:', error);
            throw error;
        }
    }
    return {
        getWidgetInfo,
        addComment,
        addReply,
        likeComment,
        unlikeComment,
        updateInteractionTime,
        pollVote
    }
}

export default useApi;
